
import { defineComponent } from "vue";

export default defineComponent({
  name: "KTLogos",
  components: {},
});
